exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sentenceStarterTextArea{position:relative}.sentenceStarterTextArea .starterWrap{position:absolute;top:7px;left:12px;right:12px;text-align:justify;pointer-events:none}.sentenceStarterTextArea .lineFix{position:absolute;width:12px;border-bottom:1px solid #ccc;padding-bottom:5px}.sentenceStarterTextArea .lineFix.rightFix{padding-bottom:6px;width:13px}.sentenceStarterTextArea textarea{margin-bottom:10px;resize:none}.sentenceStarterTextArea .starter{color:#888;border-right:1px solid #ccc;border-bottom:1px solid #ccc;border-bottom-right-radius:4px;padding-right:5px;background-color:#fff;padding-top:3px}.sentenceStarterTextArea .end{display:inline-block;opacity:0;width:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/questions/sentence_starter_text_area.scss
// module id = 1523
// module chunks = 0